// Mapping for the formation page — modules, labels, i18n strings.
// One source of truth used by formation.html / formation-us.html and formation.js.

export const MODULES = {
  1: { fr: "Module 1", en: "Module 1" },
  2: { fr: "Module 2", en: "Module 2" },
};

// UI strings, indexed by lang
export const UI = {
  fr: {
    backToPortfolio: "Retour au portfolio",
    eyebrow: "Formation Android — Accès restreint",
    heroTitle1: "Maîtrise ",
    heroTitleGrad: "Kotlin & Jetpack Compose",
    heroTitle2: "en 22 leçons",
    heroSubtitle:
      "Une formation progressive construite à partir de mon expérience terrain : théorie, exercices guidés, quiz interactifs et corrections détaillées. Trois leçons sont offertes en accès complet — le reste est disponible sur demande.",
    heroActionProgram: "Voir le programme",
    heroActionAccess: "Modalités d'accès",
    statLessons: "Leçons",
    statModules: "Modules",
    statHours: "de contenu",
    statFree: "gratuites",
    moduleLabel: "Module",
    filterAll: "Tous",
    filterModule1: "Module 1",
    filterModule2: "Module 2",
    filterLabel: "Filtrer par module",
    accessHeading: "Modalités d'accès",
    accessBannerTitle: "Aperçu gratuit",
    accessNote:
      "<strong>3 leçons offertes</strong> (1.1, 1.2, 1.3) en accès complet · les 19 autres sur demande via le <a href=\"index.html#contact\">formulaire de contact</a>.",
    accessBody:
      "<strong>Trois leçons offertes</strong> (1.1, 1.2, 1.3) vous donnent un aperçu complet : théorie, exercice, QCM et corrections. Les <strong>19 autres leçons</strong> sont présentées sous forme d'extrait : vous voyez l'objectif et l'analogie, puis vous demandez l'accès complet via le formulaire de contact.",
    programTitle: "Programme complet",
    programList:
      "<li><strong>Module 1 — Fondamentaux Kotlin &amp; Compose</strong> : 20 leçons sur les bases, le layout, la navigation, l'état, le networking, la persistance, l'injection, les tests.</li><li><strong>Module 2 — Architecture &amp; Avancé</strong> : 2 leçons sur Clean Architecture, MVI, modularisation et qualité en production.</li><li><strong>3 leçons gratuites en accès complet</strong> (théorie + exercice + QCM + corrections).</li>",
    accessCtaTitle: "Accès complet",
    accessCtaText:
      "Pour débloquer les 19 autres leçons, demande l'accès via le formulaire de contact : je te réponds sous 24h.",
    programHeading: "Programme",
    stackTitle: "Stack enseignée",
    stackBody:
      "Le parcours couvre Kotlin en profondeur, Jetpack Compose pour l'UI, MVVM et Clean Architecture, Coroutines et Flow, Room, Retrofit, Hilt, et les tests avec JUnit, MockK et Espresso.",
    ctaContact: "Demander l'accès",
    ctaCv: "Voir mon CV",
    cardOpen: "Ouvrir la leçon",
    cardPreview: "Aperçu",
    cardDuration: "min",
    badgeFree: "OFFERT",
    badgeLocked: "VERROUILLÉ",
    modalClose: "Fermer",
    modalCloseAria: "Fermer la fenêtre",
    tabTheory: "Théorie",
    tabExercise: "Exercice",
    tabQuiz: "Quiz",
    tabErrors: "Erreurs courantes",
    tabResume: "Résumé",
    theoryLabel: "Théorie",
    analogyLabel: "Analogie",
    exerciseLabel: "Exercice pratique",
    codeStart: "Code de départ",
    codeSolution: "Solution",
    hints: "Indices",
    errorTitle: "Erreur fréquente",
    why: "Pourquoi",
    fix: "Correction",
    lockedTitle: "Contenu verrouillé",
    lockedBody:
      "Cette leçon fait partie du programme complet. Pour y accéder (ainsi qu'aux 19 autres), demande l'accès via le formulaire de contact.",
    lockedBannerTitle: "Aperçu gratuit",
    lockedCtaText: "Accès complet sur demande",
    lockedCtaButton: "Demander l'accès complet",
    quizEmpty: "Aucun quiz pour cette leçon.",
    errorsEmpty: "Aucune erreur fréquente documentée.",
    next: "Leçon suivante",
    quizPerfect: "Parfait !",
    quizGreat: "Excellent !",
    quizGood: "Pas mal !",
    quizTry: "Continue à t'entraîner !",
    quizResult: "Tu as obtenu",
    quizOutOf: "sur",
    quizReviewAll: "Recommencer le quiz",
    loading: "Chargement…",
    error: "Une erreur est survenue. Réessaie plus tard.",
  },
  en: {
    backToPortfolio: "Back to portfolio",
    eyebrow: "Android Training — Restricted access",
    heroTitle1: "Master ",
    heroTitleGrad: "Kotlin & Jetpack Compose",
    heroTitle2: "in 22 lessons",
    heroSubtitle:
      "A progressive training built from my field experience: theory, guided exercises, interactive quizzes, and detailed corrections. Three lessons are free in full — the rest is available on request.",
    heroActionProgram: "See the program",
    heroActionAccess: "Access terms",
    statLessons: "Lessons",
    statModules: "Modules",
    statHours: "of content",
    statFree: "free",
    moduleLabel: "Module",
    filterAll: "All",
    filterModule1: "Module 1",
    filterModule2: "Module 2",
    filterLabel: "Filter by module",
    accessHeading: "Access terms",
    accessBannerTitle: "Free preview",
    accessNote:
      "<strong>3 lessons free in full</strong> (1.1, 1.2, 1.3) · the other 19 on request via the <a href=\"index-us.html#contact\">contact form</a>.",
    accessBody:
      "<strong>Three free lessons</strong> (1.1, 1.2, 1.3) give you a complete preview: theory, exercise, quiz and corrections. The <strong>19 other lessons</strong> are shown as excerpts: you see the goal and the analogy, then request full access via the contact form.",
    programTitle: "Full program",
    programList:
      "<li><strong>Module 1 — Kotlin &amp; Compose fundamentals</strong>: 20 lessons on basics, layout, navigation, state, networking, persistence, injection, testing.</li><li><strong>Module 2 — Architecture &amp; advanced</strong>: 2 lessons on Clean Architecture, MVI, modularisation and production quality.</li><li><strong>3 lessons free in full</strong> (theory + exercise + quiz + corrections).</li>",
    accessCtaTitle: "Full access",
    accessCtaText:
      "To unlock the 19 other lessons, request access via the contact form: I'll reply within 24h.",
    programHeading: "Program",
    stackTitle: "Stack taught",
    stackBody:
      "The track covers Kotlin in depth, Jetpack Compose for UI, MVVM and Clean Architecture, Coroutines and Flow, Room, Retrofit, Hilt, and testing with JUnit, MockK and Espresso.",
    ctaContact: "Request access",
    ctaCv: "View my CV",
    cardOpen: "Open lesson",
    cardPreview: "Preview",
    cardDuration: "min",
    badgeFree: "FREE",
    badgeLocked: "LOCKED",
    modalClose: "Close",
    modalCloseAria: "Close window",
    tabTheory: "Theory",
    tabExercise: "Exercise",
    tabQuiz: "Quiz",
    tabErrors: "Common errors",
    tabResume: "Summary",
    theoryLabel: "Theory",
    analogyLabel: "Analogy",
    exerciseLabel: "Hands-on exercise",
    codeStart: "Starting code",
    codeSolution: "Solution",
    hints: "Hints",
    errorTitle: "Common mistake",
    why: "Why",
    fix: "Fix",
    lockedTitle: "Locked content",
    lockedBody:
      "This lesson is part of the full program. To access it (along with the other 19), request access via the contact form.",
    lockedBannerTitle: "Free preview",
    lockedCtaText: "Full access on request",
    lockedCtaButton: "Request full access",
    quizEmpty: "No quiz for this lesson.",
    errorsEmpty: "No common mistakes documented.",
    next: "Next lesson",
    quizPerfect: "Perfect!",
    quizGreat: "Excellent!",
    quizGood: "Not bad!",
    quizTry: "Keep practising!",
    quizResult: "You scored",
    quizOutOf: "out of",
    quizReviewAll: "Retake the quiz",
    loading: "Loading…",
    error: "Something went wrong. Try again later.",
  },
};
